export const APP_TYPES = ['web', 'service', 'feature'];

export function reorderApps(apps) {
    return apps.sort((a, b) => {
        // return ('' + a.name).localeCompare(b.name)
        if (a.timestamp > b.timestamp) return 1
        if (a.timestamp < b.timestamp) return -1
        return 0
    })
}